export interface UserInterface {
    id: string;
    name: string;
    email: string;
}

class User {
    public constructor(
        private readonly data: UserInterface
    ) { }

    public getId() {
        return this.data.id;
    }

    public getName() {
        return this.data.name;
    }
}

export default User;
